import { useEffect, useState } from "react";
import { getAdminBoard } from "../../services/user.service";
import EventBus from "../../common/EventBus";
import UserManagement from "./table";

const BoardAdmin = () => {
  const [content, setContent] = useState({});

  useEffect(() => {
    getAdminBoard().then(
      (response) => {
        setContent(response.data);
      },
      (error) => {
        setContent(
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
            error.message ||
            error.toString()
        );

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );
  }, []);

  return (
    <div className="flex flex-col justify-center items-center py-4 w-full">
      {content?.comp === "Registry" ? <UserManagement /> : null}
    </div>
  );
};

export default BoardAdmin;
